import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, ThemeProvider, withStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import axios from 'axios'

const MAX_AGENT_CONTEXT_LENGTH = 2000

const theme = createMuiTheme({
    palette:{
        primary: {
            main:"#0b1f82"
        },
        secondary: {
            main: "#FF0000"
        }
    }
});


const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

function AgentContextDialog(props) {
    const { t } = useTranslation();

    let {onClose, handleRequestFinish, rule} = props

    const [agentContext, setAgentContext] = useState(rule.agent_context || "")
    const [isLoading, setIsLoading] = useState(false)

    const validateAllValues = () => {
        return agentContext.length <= MAX_AGENT_CONTEXT_LENGTH
    }

    const handleSaveAgentContext = () => {
        setIsLoading(true)
        let payload = {
            agent_context: agentContext.trim().length > 0 ? agentContext.trim() : null
        }
        let headersRequest = {
            headers: {
                "COMPANY-KEY": rule.company_key || "",
            },
        }
        let url = '/dash/rule_engine/company_event/' + rule.event_type.enum + "/agent_context?environment=" + rule.environment
        setTimeout(function () {
            axios.put(url, payload, headersRequest).then(response => {
                    handleRequestFinish("success", "Contexto do agente salvo com sucesso")
                }).catch(error => {
                    handleRequestFinish("error", "Não foi possível salvar o contexto do agente")
                });
        }, 500);

    }

    const handleClose = () => {
        onClose()
        setTimeout(function () {
            setAgentContext(rule.agent_context || "")
            setIsLoading(false)
        }, 500);
    }


    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            disableBackdropClick
            disableEscapeKeyDown
            keepMounted={false}
        >
            <DialogTitle
                className={['blueText', "subtitleSize"].join(" ")}
                onClose={handleClose}
            >
                {t("Contexto do Agente")}
            </DialogTitle>
            <DialogContent >
                <ThemeProvider theme={theme}>
                <div style={{padding:"20px", display:"flex", flexDirection:"column", marginBottom:"30px", width:"400px"}}>
                    {isLoading
                    ?
                    <CircularProgress style={{margin:"auto"}}/>
                    :
                    <React.Fragment>
                    <div className={["normalText", "normalMediumSize"].join(" ")} style={{marginBottom:"10px"}}>
                        {t("Descreva o contexto de negócio deste evento para o assistente de regras gerar melhores explicações e sugestões.")}
                    </div>
                    <div className={["normalText", "normalMediumSize", "bold"].join(" ")} style={{marginBottom:"10px"}}>
                        {t("Atenção: este contexto influencia a forma como o assistente interpreta TODAS as regras deste evento da empresa, não apenas esta regra.")}
                    </div>
                    <div className="internalCardContainer">
                        <TextField
                            error={!validateAllValues()}
                            helperText={agentContext.length + "/" + MAX_AGENT_CONTEXT_LENGTH}
                            label={t("Contexto do Agente")}
                            style={{textAlign:"center"}}
                            className="filterTextbox"
                            size="small" fullWidth
                            multiline
                            rows={6}
                            value={agentContext}
                            onChange={(e) => setAgentContext(e.target.value)}
                            autoFocus
                        />
                    </div>
                    <div className="internalCardContainer" style={{display:"flex", marginTop: "10px"}}>
                        <div
                            className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                            style={{width:"120px"}}
                            onClick={handleClose}
                        >
                           {t("discard")}
                        </div>
                        <div
                            className={
                                validateAllValues()
                                ?
                                ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                :
                                ["button", "standard", "normalText", "normalMediumSize","disabled"].join(" ")}
                            style={{width:"120px"}}
                            onClick={validateAllValues() ? () => handleSaveAgentContext() : null}
                        >
                            {t("save")}
                        </div>
                    </div>
                    </React.Fragment>
                    }
                </div>
                </ThemeProvider>
            </DialogContent>
        </Dialog>
    )
}

export default AgentContextDialog
